(() => {
  const FORM_SELECTOR = '.collection-quick-cart-form';
  const MINUS_SELECTOR = '[data-collection-quick-cart-minus]';
  const PLUS_SELECTOR = '[data-collection-quick-cart-plus]';
  const QTY_SELECTOR = '.collection-quick-cart__qty-input';
  const MESSAGE_SELECTOR = '.collection-quick-cart__message';

  const SECTION_IDS = ['cart-icon-bubble', 'cart-drawer'];
  const variantLocks = new Map();

  const parseHTML = (html) => new DOMParser().parseFromString(html, 'text/html');

  const getRoutes = () => {
    const routes = window.routes || {};
    const cartUrl = routes.cart_url || '/cart';

    return {
      add: routes.cart_add_url || '/cart/add',
      change: routes.cart_change_url || '/cart/change',
      cart: cartUrl,
      cartJs: `${cartUrl}.js`,
    };
  };

  const toInt = (value, fallback = 0) => {
    const number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  };

  const getVariantId = (form) => {
    const idInput = form.querySelector('input[name="id"]');
    return idInput?.value || form.dataset.variantId || '';
  };

  const getQtyInput = (form) => form.querySelector(QTY_SELECTOR);

  const getInputMin = (input) => toInt(input?.getAttribute('min'), 0);

  const getInputMax = (input) => {
    if (!input) return null;

    const maxAttr = input.getAttribute('max');

    if (maxAttr === null || maxAttr === '') return null;

    const max = toInt(maxAttr, null);
    return Number.isFinite(max) ? max : null;
  };

  const clampQty = (input, value) => {
    if (!input) return 0;

    const min = getInputMin(input);
    const max = getInputMax(input);

    let next = toInt(value, min);

    if (next < min) next = min;
    if (max !== null && next > max) next = max;

    return next;
  };

  const setInputValue = (form, quantity) => {
    const input = getQtyInput(form);
    if (!input) return;

    input.value = String(quantity);
    input.setAttribute('value', String(quantity));
    form.dataset.currentQty = String(quantity);
  };

  const setAllMatchingInputValues = (variantId, quantity) => {
    document.querySelectorAll(`${FORM_SELECTOR}[data-variant-id="${variantId}"]`).forEach((form) => {
      setInputValue(form, quantity);
    });

    document.querySelectorAll(`${FORM_SELECTOR} input[name="id"][value="${variantId}"]`).forEach((idInput) => {
      const form = idInput.closest(FORM_SELECTOR);
      if (form) setInputValue(form, quantity);
    });
  };

  const setFormLoading = (form, loading) => {
    if (!form) return;

    form.classList.toggle('collection-quick-cart-form--loading', loading);

    form.querySelectorAll('button, input').forEach((el) => {
      if (el.matches('input[name="id"]')) return;
      el.disabled = loading;
      el.toggleAttribute('aria-disabled', loading);
    });
  };

  const setAllMatchingFormsLoading = (variantId, loading) => {
    document.querySelectorAll(`${FORM_SELECTOR}[data-variant-id="${variantId}"]`).forEach((form) => {
      setFormLoading(form, loading);
    });

    document.querySelectorAll(`${FORM_SELECTOR} input[name="id"][value="${variantId}"]`).forEach((idInput) => {
      const form = idInput.closest(FORM_SELECTOR);
      if (form) setFormLoading(form, loading);
    });
  };

  const setMessage = (form, message, type = 'success') => {
    if (!form) return;

    const messageEl = form.querySelector(MESSAGE_SELECTOR);
    if (!messageEl) return;

    messageEl.textContent = message || '';
    messageEl.classList.toggle('collection-quick-cart__message--error', type === 'error');
    messageEl.classList.toggle('collection-quick-cart__message--success', type === 'success' && Boolean(message));

    window.clearTimeout(messageEl.collectionQuickCartTimer);

    if (message) {
      messageEl.collectionQuickCartTimer = window.setTimeout(() => {
        messageEl.textContent = '';
        messageEl.classList.remove('collection-quick-cart__message--error');
        messageEl.classList.remove('collection-quick-cart__message--success');
      }, 2500);
    }
  };

  const getErrorMessage = async (response) => {
    try {
      const data = await response.json();
      return data.description || data.message || 'カートを更新できませんでした。';
    } catch (error) {
      return 'カートを更新できませんでした。';
    }
  };

  const updateCartIconFallback = (cart) => {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !cart) return;

    const count = cart.item_count || 0;
    const countBubble = bubble.querySelector('.cart-count-bubble');

    if (!countBubble) return;

    const visibleCount =
      countBubble.querySelector('span[aria-hidden="true"]') ||
      countBubble.querySelector('span:not(.visually-hidden)');

    const hiddenCount = countBubble.querySelector('.visually-hidden');

    if (visibleCount) visibleCount.textContent = String(count);
    if (hiddenCount) hiddenCount.textContent = `${count}個のアイテム`;

    countBubble.classList.toggle('hidden', count === 0);
  };

  const updateCartDrawerFallback = async () => {
    const drawer = document.querySelector('cart-drawer');
    const currentDrawerInner = document.querySelector('#CartDrawer .drawer__inner');

    if (!drawer || !currentDrawerInner) return;

    try {
      const response = await fetch('/?sections=cart-drawer', {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
      });

      if (!response.ok) return;

      const sections = await response.json();
      const html = sections['cart-drawer'];

      if (!html) return;

      const newDrawerInner = parseHTML(html).querySelector('#CartDrawer .drawer__inner, .drawer__inner');

      if (!newDrawerInner) return;

      currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      drawer.classList.remove('is-empty');
    } catch (error) {
      console.warn('Cart drawer fallback update failed:', error);
    }
  };

  const updateSectionsFromResponse = (sections, cart) => {
    if (!sections) return false;

    let updated = false;

    if (sections['cart-icon-bubble']) {
      const currentBubble = document.getElementById('cart-icon-bubble');
      const newBubble = parseHTML(sections['cart-icon-bubble']).querySelector('#shopify-section-cart-icon-bubble');

      if (currentBubble && newBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
        updated = true;
      }
    }

    if (sections['cart-drawer']) {
      const drawer = document.querySelector('cart-drawer');
      const currentDrawerInner = document.querySelector('#CartDrawer .drawer__inner');
      const newDrawerInner = parseHTML(sections['cart-drawer']).querySelector('#CartDrawer .drawer__inner, .drawer__inner');

      if (drawer && currentDrawerInner && newDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
        drawer.classList.toggle('is-empty', !cart || cart.item_count === 0);
        updated = true;
      }
    }

    return updated;
  };

  const fetchCart = async () => {
    const { cartJs } = getRoutes();

    const response = await fetch(cartJs, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) return null;

    return response.json();
  };

  const getQuantityInCart = (cart, variantId) => {
    if (!cart || !Array.isArray(cart.items)) return 0;

    const variantIdNumber = Number(variantId);

    return cart.items
      .filter((item) => Number(item.variant_id) === variantIdNumber)
      .reduce((total, item) => total + Number(item.quantity || 0), 0);
  };

  const publishCartUpdate = (cartData, source = 'collection-quick-cart') => {
    if (window.PUB_SUB_EVENTS && typeof window.publish === 'function') {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source,
        cartData,
      });
    }
  };

  const refreshCartView = async (sectionsFromResponse = null, cartFromResponse = null) => {
    const cart = cartFromResponse || (await fetchCart());

    if (sectionsFromResponse) {
      updateSectionsFromResponse(sectionsFromResponse, cart);
    } else {
      updateCartIconFallback(cart);
      await updateCartDrawerFallback();
    }

    if (cart) {
      updateCartIconFallback(cart);
      publishCartUpdate(cart);
    }

    return cart;
  };

  const requestAddOne = async (variantId) => {
    const { add } = getRoutes();

    const response = await fetch(`${add}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        sections: SECTION_IDS,
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error(await getErrorMessage(response));
    }

    return response.json();
  };

  const requestChangeQuantity = async (variantId, quantity) => {
    const { change } = getRoutes();

    const response = await fetch(`${change}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: String(variantId),
        quantity: Number(quantity),
        sections: SECTION_IDS,
        sections_url: window.location.pathname,
      }),
    });

    if (!response.ok) {
      throw new Error(await getErrorMessage(response));
    }

    return response.json();
  };

  const runLocked = async (variantId, callback) => {
    const previous = variantLocks.get(variantId) || Promise.resolve();

    const next = previous
      .catch(() => undefined)
      .then(callback)
      .finally(() => {
        if (variantLocks.get(variantId) === next) {
          variantLocks.delete(variantId);
        }
      });

    variantLocks.set(variantId, next);

    return next;
  };

  const updateVariantQuantity = async (form, action, directValue = null) => {
    const variantId = getVariantId(form);
    const input = getQtyInput(form);

    if (!variantId || !input) {
      setMessage(form, '商品情報を取得できませんでした。', 'error');
      return;
    }

    const previousQty = clampQty(input, input.value);
    const max = getInputMax(input);

    let targetQty = previousQty;

    if (action === 'plus') {
      targetQty = previousQty + 1;
    } else if (action === 'minus') {
      targetQty = previousQty - 1;
    } else if (action === 'set') {
      targetQty = directValue;
    }

    targetQty = clampQty(input, targetQty);

    if (max !== null && action === 'plus' && previousQty >= max) {
      setInputValue(form, previousQty);
      setMessage(form, `在庫上限は${max}点です。`, 'error');
      return;
    }

    if (targetQty === previousQty && action !== 'set') {
      setInputValue(form, previousQty);
      return;
    }

    await runLocked(variantId, async () => {
      const latestCartBefore = await fetchCart();
      const latestQty = getQuantityInCart(latestCartBefore, variantId);

      let finalTargetQty = targetQty;

      if (action === 'plus') {
        finalTargetQty = latestQty + 1;

        if (max !== null && finalTargetQty > max) {
          finalTargetQty = max;
        }
      } else if (action === 'minus') {
        finalTargetQty = Math.max(0, latestQty - 1);
      } else if (action === 'set') {
        finalTargetQty = clampQty(input, directValue);
      }

      const beforeQty = latestQty;

      setAllMatchingFormsLoading(variantId, true);
      setMessage(form, '');

      try {
        let parsedState;

        if (action === 'plus' && finalTargetQty === latestQty + 1) {
          parsedState = await requestAddOne(variantId);
        } else {
          parsedState = await requestChangeQuantity(variantId, finalTargetQty);
        }

        const cart = await refreshCartView(parsedState.sections);
        const actualQty = getQuantityInCart(cart, variantId);

        setAllMatchingInputValues(variantId, actualQty);

        if (actualQty > beforeQty) {
          setMessage(form, 'カートに追加しました。', 'success');
        } else if (actualQty < beforeQty) {
          setMessage(form, 'カート数量を更新しました。', 'success');
        } else {
          setMessage(form, '');
        }
      } catch (error) {
        console.error(error);

        const cart = await fetchCart();
        const actualQty = getQuantityInCart(cart, variantId);

        setAllMatchingInputValues(variantId, actualQty);
        updateCartIconFallback(cart);

        setMessage(form, error?.message || 'カートを更新できませんでした。', 'error');
      } finally {
        setAllMatchingFormsLoading(variantId, false);
      }
    });
  };

  const handleClick = (event) => {
    const plusButton = event.target.closest(PLUS_SELECTOR);
    const minusButton = event.target.closest(MINUS_SELECTOR);

    if (!plusButton && !minusButton) return;

    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    updateVariantQuantity(form, plusButton ? 'plus' : 'minus');
  };

  const handleInputChange = (event) => {
    const input = event.target.closest(QTY_SELECTOR);
    if (!input) return;

    const form = input.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    const targetQty = clampQty(input, input.value);
    updateVariantQuantity(form, 'set', targetQty);
  };

  const preventSubmit = (event) => {
    const form = event.target.closest(FORM_SELECTOR);
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();
  };

  const syncInitialCartQuantities = async () => {
    const forms = Array.from(document.querySelectorAll(FORM_SELECTOR));
    if (!forms.length) return;

    try {
      const cart = await fetchCart();
      if (!cart) return;

      forms.forEach((form) => {
        const variantId = getVariantId(form);
        if (!variantId) return;

        const qty = getQuantityInCart(cart, variantId);
        setInputValue(form, qty);
      });

      updateCartIconFallback(cart);
    } catch (error) {
      console.warn('Initial collection quick cart sync failed:', error);
    }
  };

  document.addEventListener('click', handleClick, true);
  document.addEventListener('change', handleInputChange, true);
  document.addEventListener('submit', preventSubmit, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncInitialCartQuantities);
  } else {
    syncInitialCartQuantities();
  }
})();